<p-toast position="top-right"></p-toast>
<p-confirmdialog />
<socium-main-layout
  [companyId]="selectedCompanyId"
  [asideParams]="asideParams"
  [headerParams]="headerParams"
  [appsParams]="appsParams"
  (companyChange)="handleSelectCompany($event)"
  (languageChange)="onLanguageChange($event)"
  (myProfile)="handleNavigateToUserProfile()"
  (loggedOut)="logout()"
>

  <app-toolbar ngProjectAs="custom-header" />

  <ngx-spinner
    size="medium"
    color="#0573e880"
    type="ball-clip-rotate"
    bdColor="rgba(233,236,239,0.7)"
    [fullScreen]="true"
  />

  <router-outlet></router-outlet>
</socium-main-layout>
